import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';

import { createIconComponent } from 'uikit/icons';

import styles from '../styles/uikitInputsCheckbox.module.scss';

const Checkbox = ({
  id = '',
  className = '',
  value = false,
  label = '',
  labelPosition = 'right',
  isDisabled = false,
  isIndeterminate = false,
  onChange = () => {},
  onKeyDown = () => {},
  onFocus = () => {},
  onBlur = () => {},
  testId = '',
  inputTestId = '',
  inputAriaLabel = '',
  checkedIcon = <CheckBox />,
  uncheckedIcon = <CheckBoxOutlineBlank />,
  indeterminateIcon = <IndeterminateCheckBoxIcon />,
  fieldKey = '',
  isChecked = undefined,
}) => {
  const Label = (
    <label htmlFor={id} className={styles.label}>
      {label}
    </label>
  );
  const isCheckboxChecked = isChecked !== undefined ? isChecked : value;

  let icon = uncheckedIcon;
  if (isCheckboxChecked) icon = checkedIcon;
  if (isIndeterminate) icon = indeterminateIcon;

  const IconComponent = createIconComponent({
    icon,
    size: 18,
    className: isCheckboxChecked ? styles.checked : styles.unchecked,
  });

  return (
    <div
      className={classnames(
        styles.element,
        {
          [styles.isPositionedLeft]: labelPosition === 'left',
          [styles.isPositionedRight]: labelPosition !== 'left',
          [styles.isDisabled]: isDisabled,
          [styles.isIndeterminate]: isIndeterminate,
        },
        className,
      )}
      data-testid={testId}
    >
      {label && labelPosition === 'left' && Label}
      <div className={styles.icon}>
        <input
          aria-label={inputAriaLabel}
          className={styles.input}
          id={id}
          type="checkbox"
          name={fieldKey}
          checked={isCheckboxChecked}
          value={value}
          onKeyDown={onKeyDown}
          onChange={(event) => onChange(event.target.checked)}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={isDisabled}
          data-testid={inputTestId}
        />
        {IconComponent}
      </div>
      {label && labelPosition === 'right' && Label}
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(['left', 'right']),
  isDisabled: PropTypes.bool,
  isIndeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  testId: PropTypes.string,
  inputTestId: PropTypes.string,
  inputAriaLabel: PropTypes.string,
  checkedIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  uncheckedIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  indeterminateIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  fieldKey: PropTypes.string,
  isChecked: PropTypes.bool,
};

export { Checkbox as CheckboxStorybook };
export default React.memo(Checkbox);
